// extracted by mini-css-extract-plugin
export var cardHeader = "_hy-0";
export var reorderHandle = "_hy-3";
export var titleArea = "_hy-1";
export var titleAreaWithHandle = "_hy-2";